import Brand from "./pages/brands/Brand";
import BrandDetail from "./pages/brands/[id]/BrandDetail";
import BranchDetail from "./pages/brands/[id]/branches/BranchDetail";
import Map from "./pages/Map";
import DriversList from "./pages/drivers/home/DriversList";
import DashboardLayout from "./layouts/DashboardLayout";
import GenericLayout from "./layouts/GenericLayout";

import OrdersApp from "./pages/orders-new/order-app";
import OrdersLayout from "./pages/orders-new/orders-layout";
import ProtectedSettings from "./pages/settings/ProtectedSettings";
import MyProfile from "./pages/profile/MyProfile";
import Dashboard from "./pages/dashboard/Index";
import DriverDetail from "./pages/drivers/detail/DriverDetail";
import HistoricalOrders from "./pages/orders/HistoricalOrders";
import DriverPortal from "./pages/DriverPortal";
import Unauthorized from "./pages/Unauthorized";
import TermsConditions from "./pages/terms/TermsConditions";
import UserDeactivated from "./pages/UserDeactivated";
import NotFound from "./pages/NotFound";
import OrderDetail from "./pages/orders-new/order-detail";

interface Route {
  path: string;
  name: string;
  element?: React.ComponentType<any>;
  children?: Route[];
  allowedRoles?: string[]; // Add role restrictions
}

const routes: Route[] = [
  // Driver Portal - Only for drivers
  {
    path: "driver-portal",
    name: "Driver Portal",
    element: DriverPortal,
    allowedRoles: ["driver"],
  },

  // Unauthorized page - accessible to all authenticated users
  {
    path: "unauthorized",
    name: "Unauthorized",
    element: Unauthorized,
  },

  {
    path: "/orders",
    name: "Orders",
    element: OrdersLayout,
    allowedRoles: ["manager", "admin"],
    children: [
      {
        path: "",
        name: "Orders List",
        element: OrdersApp,
      },
      {
        path: ":orderId",
        name: "Order Detail",
        element: OrderDetail,
      },
    ],
  },

  // Dashboard route - Customer/Admin only
  {
    path: "/",
    name: "Dashboard",
    element: DashboardLayout,
    allowedRoles: ["manager", "admin"],
    children: [{ path: "", name: "Dashboard", element: Dashboard }],
  },

  // Other routes with GenericLayout
  {
    path: "/",
    name: "Generic",
    element: GenericLayout,
    children: [
      // Settings - Admin only
      {
        path: "settings",
        name: "Settings",
        element: ProtectedSettings,
        allowedRoles: ["admin"],
      },

      // Profile - All authenticated users can access
      { path: "my-profile", name: "My Profile", element: MyProfile },

      // Historical Orders - Customer/Admin only
      {
        path: "orders/historical",
        name: "Historical Orders",
        element: HistoricalOrders,
        allowedRoles: ["manager", "admin"],
      },

      // Business Management - Customer/Admin only
      {
        path: "brands",
        name: "Business Management",
        element: Brand,
        allowedRoles: ["manager", "admin"],
      },
      {
        path: "brands/:id",
        name: "Brand Detail",
        element: BrandDetail,
        allowedRoles: ["manager", "admin"],
      },
      {
        path: "brands/:brandId/branches/:branchId",
        name: "Branch Detail",
        element: BranchDetail,
        allowedRoles: ["manager", "admin"],
      },

      // Map - All authenticated users can access (drivers need to see map)
      {
        path: "map",
        name: "Map",
        element: Map,
        allowedRoles: ["manager", "admin"],
      },

      // Drivers Management - Customer/Admin only
      {
        path: "drivers",
        name: "Drivers List",
        element: DriversList,
        allowedRoles: ["manager", "admin"],
      },
      {
        path: "drivers/:id",
        name: "Driver Detail",
        element: DriverDetail,
        allowedRoles: ["manager", "admin"],
      },
    ],
  },
  { path: "/terms", name: "Terms", element: TermsConditions },
  {
    path: "/user-deactivated",
    name: "User Deactivated",
    element: UserDeactivated,
  },
  { path: "*", name: "Not Found", element: NotFound },
];

export default routes;
